import articles from './editorial/articles.json';
import pillars from './editorial/pillars.json';
import { filterPublished } from '../lib/publication';

const publishedPillars = filterPublished(pillars);
const publishedArticles = filterPublished(articles);
const publishedSlugs = new Set(publishedArticles.map(post => post.slug));
const publishedPaths = new Set([
  ...publishedPillars.map(pillar => pillar.path),
  ...publishedArticles.map(post => `/fr/blog/${post.slug}`),
]);
const unavailablePaths = new Set([
  ...pillars.map(pillar => pillar.path),
  ...articles.map(post => `/fr/blog/${post.slug}`),
].filter(path => !publishedPaths.has(path)));

// Keep dependency flow one-way: blogConfig can reuse this for legacy articles
// without editorial importing blogConfig or the metadata/route catalog.
export function resolvePublishedLinks(item, availableSlugs = publishedSlugs) {
  return {
    ...item,
    ...(item.body ? { body: item.body.map(block => {
      const path = typeof block.to === 'string' ? block.to.split(/[?#]/)[0].replace(/\/+$/, '') : null;
      return block.type === 'link' && unavailablePaths.has(path)
        ? { type: 'p', text: `${block.before || ''}${block.text}${block.after || ''}` }
        : block;
    }) } : {}),
    ...(item.relatedSlugs ? { relatedSlugs: item.relatedSlugs.filter(slug => availableSlugs.has(slug)) } : {}),
  };
}

export const PILLARS = publishedPillars.map(pillar => resolvePublishedLinks(pillar));
export const EDITORIAL_POSTS = publishedArticles.map(post => ({
  ...resolvePublishedLinks(post),
  cat: PILLARS.find(p => p.id === post.cluster)?.title || 'Guides',
})).sort((a, b) => (b.editorialDate || '').localeCompare(a.editorialDate || ''));
export const pillarFor = cluster => PILLARS.find(p => p.id === cluster);
export const articlesFor = cluster => EDITORIAL_POSTS.filter(p => p.cluster === cluster);
export const formatDate = iso => new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${iso}T12:00:00Z`));
